/*
 * @Author: wangyan1 wangyan1
 * @Date: 2023-10-16 16:53:11
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-10 14:22:25
 * @FilePath: /teacher-xkh-web/src/service/supervision/index-url.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let baseUrl = ''
if (process.env.NODE_ENV === 'development') {
  baseUrl = '/xkh/teacherapi'
} else {
  baseUrl = '//xkhteacher.aixuexi.com/xkh/teacherapi'
}

export default {
  // 获取学生列表 https://yapi.aixuexi.com/project/42/interface/api/193529
  getSupervisionStudentList: `${baseUrl}/student/lesson/superviseClassList`,
  // 未开始学习学员列表 https://yapi.aixuexi.com/project/42/interface/api/193532
  absenteesStudent: `${baseUrl}/correction/student/notstart`,
  // 根据班型获取讲次信息 https://yapi.aixuexi.com/project/42/interface/api/196832
  getLessonsByClassId: `${baseUrl}/base/lesson/list`,
  // 教师控-查询一键暂停列表信息 https://yapi.aixuexi.com/project/42/interface/api/197342
  lessonList: `${baseUrl}/student/lesson/suspendList`,
  // 是否含精准学小组https://yapi.aixuexi.com/project/42/interface/api/203939
  hasJzxGroup: `${baseUrl}/course/hasJzxGroup`,
  // 授课控制一键暂停/一键开始 https://yapi.aixuexi.com/project/42/interface/api/197354
  setPlaystate: (id, status) => `${baseUrl}/course/courseware/playstate/${id}/${status}`,
  speedConfigList: `${baseUrl}/student/lesson/speedConfigList`,
  setSpeedState: (id, status) => `${baseUrl}/course/speed/disable/${id}/${status}`,
  getGroupLessons: `${baseUrl}/base/grouplesson/list`
}
